import { Panel } from "../layout/Panel.tsx";
import { MetricCard } from "../viz/MetricCard.tsx";
import { metrics } from "../../stores/metrics.ts";

/**
 * Ad Stack metrics from NR Browser custom events:
 *   PrebidAuctionEvent → fill_rate, refresh_error_rate, prebid_latency_p95_ms
 *   IMAIntegrationEvent → ima_success_rate
 */
export function AdStackPanel() {
  const get = (m: string) => metrics.latest[`newrelic-ads:${m}`]?.value;
  return (
    <Panel title="Ad Stack · Prebid + IMA" span="col-span-4">
      <div class="grid grid-cols-2 gap-3">
        <MetricCard label="Fill Rate" value={get("fill_rate")} unit="%" digits={1} />
        <MetricCard label="Errors" value={get("refresh_error_rate")} unit="%" digits={2} />
        <MetricCard label="Prebid p95" value={get("prebid_latency_p95_ms")} unit="ms" digits={0} />
        <MetricCard label="IMA Success" value={get("ima_success_rate")} unit="%" digits={1} />
      </div>
    </Panel>
  );
}
